import { Link } from 'react-router-dom';

function industryName(original) {
  return (
    <Link to={`/industries/edit/${original?.id}`}>
      {original?.industryName || ''}
    </Link>
  );
}

function industryCode(original) {
  return original?.industryCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { industryName, industryCode, status };
